import React from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <div className="nav">
      <div style={{ display: "none" }} className="toggleButton">
        <button></button>
      </div>
      <NavLink to="/">Home</NavLink>
      <NavLink to="/about">About</NavLink>
      <NavLink to="/projects">Projects</NavLink>
      <NavLink to="/beyondwork">Beyond Work</NavLink>
    </div>
  );
}

export default Navbar;
